import { observer } from "mobx-react";
// 重构报错信息
export function observer_(Component) {
    try {
        return observer(Component);
    } catch (e) {
        var _Component_displayName, _ref;
        throw new Error("[VM]: ".concat((_ref = (_Component_displayName = Component.displayName) !== null && _Component_displayName !== void 0 ? _Component_displayName : Component.name) !== null && _ref !== void 0 ? _ref : "unknown", "\n").concat(e.message));
    }
}
